<template>
  <div class="page">
    <div class="title">
      <span>企业钱包认证</span>
    </div>
    <div class="content">
      <div class="content-title">
        {{ steps == 1 ? "商户入网信息" : "证件上传" }}
      </div>
      <!-- 表单 -->
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <template v-if="steps == 1">
            <div class="formTitle">
              <div>签约信息</div>
              <el-divider></el-divider>
            </div>
            <el-form-item label="签约名称">
              <el-input :value="identifyInfo.companyName" readonly></el-input>
            </el-form-item>
            <el-form-item label="法人姓名">
              <el-input :value="identifyInfo.legalName" readonly></el-input>
            </el-form-item>
            <el-form-item label="法人身份证">
              <el-input :value="identifyInfo.idCardNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="组织机构代码">
              <el-input
                :value="identifyInfo.businessLicenseNo"
                readonly
              ></el-input>
            </el-form-item>
            <div class="formTitle">
              <div>银行卡信息</div>
              <el-divider></el-divider>
            </div>
            <el-form-item label="开户账号" prop="bankNo">
              <el-input
                v-model="ruleForm.bankNo"
                clearable
                placeholder="请输入"
                @blur="bankNoBlur"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户名">
              <el-input :value="identifyInfo.companyName" readonly></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="bankCode">
              <!-- <el-input v-model="ruleForm.shopName" placeholder="请输入"></el-input> -->
              <el-select
                v-model="ruleForm.bankCode"
                @change="bankChange"
                filterable
                clearable
                placeholder="请选择（支持输入关键字搜索）"
              >
                <el-option
                  :label="item.bankName"
                  :value="item.bankCode"
                  v-for="item in picker"
                  :key="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="formTitle">
              <div>结算信息</div>
              <el-divider></el-divider>
            </div>
            <el-form-item label="结算账户类型">
              <el-input value="对公" readonly></el-input>
            </el-form-item>
            <el-form-item label="结算类型">
              <el-input value="T1" readonly></el-input>
            </el-form-item>
            <el-form-item label="结算方式">
              <el-input value="自动结算" readonly></el-input>
            </el-form-item>
            <el-form-item label="授权使用平台商秘钥">
              <el-switch :value="true" disabled></el-switch>
            </el-form-item>
            <!-- <div class="formTitle">
              <div>鉴权</div>
              <el-divider></el-divider>
            </div>
            <el-form-item label="手机号" prop="legalMobile">
              <el-input
                v-model="ruleForm.legalMobile"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <div style="display: flex">
                <el-input
                  v-model="ruleForm.code"
                  maxlength="6"
                  clearable
                  placeholder="请输入六位验证码"
                ></el-input>
                <el-button
                  type="primary"
                  @click="payBindCardPreOrder"
                  :disabled="!showSendCodeBtn"
                  style="margin-left: 10px"
                  >{{
                    countDown == 60
                      ? "发送验证码"
                      : "重新发送(" + countDown + "S)"
                  }}</el-button
                >
              </div>
            </el-form-item> -->
          </template>
          <template v-if="steps == 2">
            <el-form-item label="开户许可证（需加盖公章）" prop="region">
              <el-upload
                class="avatar-uploader"
                :loading="uploading"
                ref="upload"
                action="action"
                :http-request="(file) => uploadRequest(file, 1)"
                :before-upload="beforeUpload"
                :limit="1"
                :show-file-list="false"
              >
                <img
                  v-if="imageForm.openingPermitUrl"
                  :src="imageForm.openingPermitUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="店铺门面照" prop="region">
              <el-upload
                class="avatar-uploader"
                :loading="uploading"
                ref="upload"
                action="action"
                :http-request="(file) => uploadRequest(file, 2)"
                :before-upload="beforeUpload"
                :limit="1"
                :show-file-list="false"
              >
                <img
                  v-if="imageForm.companyFaceUrl"
                  :src="imageForm.companyFaceUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </template>
          <el-form-item>
            <div class="btn">
              <!-- <el-button @click="resetForm('ruleForm')">保存草稿</el-button> -->
              <el-button @click="steps -= 1" v-if="steps != 1"
                >上一步</el-button
              >
              <el-button
                type="primary"
                @click="submitForm1('ruleForm')"
                v-if="steps == 1"
                >下一步</el-button
              >
              <el-button
                type="primary"
                @click="submitForm2"
                :disabled="
                  !(imageForm.openingPermitUrl && imageForm.companyFaceUrl)
                "
                v-if="steps == 2"
                >提交</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="contentAfter">
        <div>
          <el-steps direction="vertical" :active="steps">
            <el-step
              title="企业信息"
              description="(对应个人认证的实名认证)"
            ></el-step>
            <el-step
              title="法人信息"
              description="(对应个人认证的基础信息完善)"
            ></el-step>
          </el-steps>
        </div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>
<script>
let BIN = require("bankcardinfo");
import BMF from "browser-md5-file";
import QS from 'qs'
export default {
  data() {
    return {
      steps: 1,
      identifyInfo: {},
      rules: {
        legalMobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        bankNo: [
          { required: true, message: "请输入开户账号", trigger: "blur" },
        ],
        bankCode: [
          { required: true, message: "请选择开户银行", trigger: "change" },
        ],
      },
      ruleForm: {
        bankNo: "",
        bankCode: "",
        bankName: "",
        legalIdNo: "",
        legalMobile: "",
        legalName: "",
      },
      uploading: false,
      picker: [],
      countDown: 60,
      imageForm: {},
    };
  },
  computed: {
    showSendCodeBtn() {
      return Boolean(
        this.ruleForm.bankNo &&
          this.ruleForm.bankCode &&
          this.ruleForm.legalMobile &&
          this.countDown == 60
      );
    },
  },
  created() {
    this.getBankCode();
    this.getIdentifyInfo();
  },
  mounted() {},
  methods: {
    bankChange(v) {
      let list = this.picker.filter((ele) => {
        return ele.bankCode == v;
      });
      this.ruleForm.bankName = list[0].bankName;
    },
    // 发送手机验证码
    payBindCardPreOrder() {
      if (!this.ruleForm.legalMobile) return;
      let params = {
        bankCode: this.ruleForm.bankCode,
        bankName: this.ruleForm.bankName,
        bankNo: this.ruleForm.bankNo,
        legalIdNo: this.identifyInfo.idCardNo,
        legalMobile: this.identifyInfo.legalPhone,
        legalName: this.identifyInfo.legalName,
      };
      this.$http.payBindCardPreOrder(params).then((res) => {
        if (res.code == 0 && res.data) {
          this.$message({
            message: "短信发送成功，请查收",
            type: "success",
          });
          this.resetForm.orderNo = res.data;
          this.setTime();
        } else {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    setTime() {
      if (this.countDown == 0) {
        this.countDown = 60;
      } else {
        this.countDown--;
      }
      setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    getIdentifyInfo() {
      this.$http.getIdentifyInfo({ detail: false }).then((res) => {
        if (res.code == 0 && res.data) {
          this.identifyInfo = res.data;
          this.ruleForm.legalMobile = res.data.legalPhone;
          this.ruleForm.legalIdNo = res.data.idCardNo;
          this.ruleForm.legalName = res.data.legalName;
        }
      });
    },
    bankNoBlur() {
      if (!this.ruleForm.bankNo) return;
      this.ruleForm.bankNo = this.ruleForm.bankNo.replace(/\s+/g, "");
      BIN.getBankBin(this.ruleForm.bankNo).then((res) => {
        this.ruleForm.bankName = res.bankName;
        let index = this.picker.findIndex(
          (ele) => ele.bankName.indexOf(res.bankName) != -1
        );
        console.log(index);
        if (index) {
          this.ruleForm.bankCode = this.picker[index].bankCode;
        } else {
          this.ruleForm.bankCode = "";
        }
      });
    },
    // 获取银行列表
    getBankCode() {
      this.$http.getBankCode().then((res) => {
        if (res.code == 0 && res.data) {
          this.picker = res.data;
        }
      });
    },
    // 上传前校验
    beforeUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 2MB!');
      // }
      return true;
    },
    //上传
    async uploadRequest(file, type) {
      let md5 = await this.transportFile(file);
      const formData = {
        attachmentObjectTypeCode: "chinaumsFiles",
        fileSize: file.file.size,
        md5: md5,
        originalFilename: file.file.name,
        isEncryption: true,
      };
      this.uploading = true;
      this.$http.Upload(formData).then((res) => {
        console.log(res);
        let url = res.data.presignedUploadUrl;
        let md5Base64 = res.data.md5Base64;
        if (res.code == 0) {
			let urlArr = res.data.fileUrl.split('.') 
			let imgType = urlArr[urlArr.length - 1]
			
          this.$http
            .uploadToServer(url, md5Base64, file.file, res.data.mimeType)
            .then((resp) => {
              console.log(resp);
              this.uploading = false;
              if (resp.status == 200) {
                if (type == 1) {
                  this.imageForm.openingPermitSize = res.data.fileSize; // 开户许可证大小
                  // this.imageForm.openingPermitType = res.data.mimeType; // 开户许可证类型
                  this.imageForm.openingPermitType = imgType; // 开户许可证类型
                  this.imageForm.openingPermitUrl = res.data.fileUrl; // 开户许可证类型
                } else {
                  this.imageForm.companyFaceSize = res.data.fileSize; // 店铺门面照大小
                  // this.imageForm.companyFaceType = res.data.mimeType; // 店铺门面照类型
                  this.imageForm.companyFaceType = imgType; // 店铺门面照类型
                  this.imageForm.companyFaceUrl = res.data.fileUrl; // 店铺门面照路径
                }
              } else {
                this.$notify({
                  title: "提示",
                  message: "上传失败",
                });
              }
            });
        } else {
          this.uploading = false;
          this.$notify({
            title: "提示",
            message: "上传失败",
          });
        }
      });
      return false;
    },
    transportFile(file) {
      const bmf = new BMF();
      return new Promise((resolve, reject) => {
        bmf.md5(file.file, (err, md5) => {
          resolve(md5);
        });
      });
    },
    bankInput() {
      if (!this.ruleForm.bankAcctNo) return;
      // 根据银行卡号识别 银行（这是异步的）
      this.ruleForm.bankAcctNo = this.ruleForm.bankAcctNo.replace(/\s+/g, "");
      BIN.getBankBin(this.ruleForm.bankAcctNo).then((res) => {
        this.ruleForm.bankBranchName = res.bankName;
      });
    },
    submitForm1(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.$http.companyWalletFirst(that.ruleForm).then((res) => {
            if (res.code == 0) {
              that.$message({
                message: "保存成功",
                type: "success",
              });
              that.steps = 2;
            } else {
              // that.$message({
              //   message: res.msg,
              //   type: "success",
              // });
            }
          });
        }
      });
    },
    submitForm2() {
      let params = {
        ...this.imageForm,
        bankNo: this.ruleForm.bankNo,
      };
      this.$http.companyWalletSecond(params).then((r) => {
        if (r.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
		  this.qianyueModule()
          let url = `${r.data.url}?${QS.stringify(r.data)}`
          console.log(url);
          window.open(url)
        } else {
          this.$message({
            message: r.msg,
            type: "success",
          });
        }
      });
    },
	// 弹窗
	qianyueModule() {
		this.$alert('请在弹出的新窗口完成签约，签约结果预计在十分钟内生效，点击下方按钮返回支付认证刷新签约状态', '签约提示', {
			confirmButtonText: '确定',
			callback: action => {
				this.$router.replace("/agencyRegister/createShop");
			}
		});
	},
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
div.page {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 20px 0;
  div.btn {
    display: flex;
    justify-content: center;
    padding: 40px 0 20px;
    .el-button {
      width: 50%;
      //   margin: 40px auto 0;
    }
  }
  div.title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 40vw;
    min-width: 500px;
    margin: auto;
    padding: 20px 0;
    & > span:first-of-type {
      font-size: 18px;
      color: #303133;
    }
    span {
      font-size: 16px;
      color: #606266;
    }
  }
  div.content {
    width: 40vw;
    min-width: 500px;
    min-height: 100vh;
    margin: auto;
    // padding: 20px;
    background: #ffffff;
    border: 1px solid #dfe2e7;
    position: relative;

    div.content-title {
      padding: 20px;
      font-size: 16px;
      text-align: center;
      background-color: #f5f6f8;
      border-bottom: 1px solid #dfe2e7;
    }
    div.form {
      padding: 20px;
      background: #ffffff;
      .formTitle {
        font-size: 16px;
        font-weight: bold;
        padding-top: 30px;
      }
      .formTitle:first-of-type {
        padding-top: 10px;
      }
    }
    form.el-form {
      padding: 20px;
      background: #f3f6f9;
    }
    div.contentAfter {
      background-color: #ffffff;
      border: 1px solid #dfe2e7;
      width: 250px;
      position: absolute;
      top: 0;
      right: -310px;
      padding: 20px;
    }
  }

  .el-form-item__content {
    display: flex;
    & > div {
      flex: 1;
    }
  }
  .el-step__main {
    margin-bottom: 10px;
  }
  .avatar-uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    ::v-deep .el-upload:hover {
      border-color: #409eff;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-select {
    width: 100%;
  }
}
</style>
